import { render, staticRenderFns } from "./Mother.vue?vue&type=template&id=3a2a4e64&scoped=true"
import script from "./Mother.vue?vue&type=script&lang=js"
export * from "./Mother.vue?vue&type=script&lang=js"
import style0 from "./Mother.vue?vue&type=style&index=0&id=3a2a4e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2a4e64",
  null
  
)

export default component.exports